export default __webpack_public_path__ + "static/media/likert-face-4.a3c5de77.svg";